import {
    NOTIFY_ADD_SUCCESS,
  NOTIFY_FAIL,
  NOTIFY_REQUEST,
  NOTIFY_SUCCESS,
} from "../Actions/NotificationAction";

export const notificationReducer = (state = { notifyData: [] }, action) => {
  switch (action.type) {
    case NOTIFY_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case NOTIFY_SUCCESS:
      return {
        ...state,
        notifyData:action.payload,
        loading: false,
      };
    case NOTIFY_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
      case NOTIFY_ADD_SUCCESS:
        return {
          ...state,
          notify:action.payload,
          loading: false,
        };
    default:
      return state;
  }
};
